import { Component, OnInit } from "@angular/core";
import { OrganisationInterface } from "@careapp/angular-sdk";
import { Store } from "@ngrx/store";
import { Observable, BehaviorSubject, combineLatest } from "rxjs";

import { Organisations } from "../../store/actions/index";
import * as selectors from "../../store/reducers/index";
import { FormControl } from "@angular/forms";
import { filter, withLatestFrom, map } from "rxjs/operators";

@Component({
  selector: "admin-organisations",
  templateUrl: "./organisations.component.html",
  styleUrls: ["./organisations.component.scss"]
})
export class OrganisationsComponent implements OnInit {
  organisations: Observable<Array<OrganisationInterface>>;
  loading$: Observable<boolean>;
  currentFilter = new BehaviorSubject("enabled");

  filterControl = new FormControl("enabled");

  constructor(private store: Store<any>) {
    this.organisations = combineLatest(
      this.store.select(selectors.getAll(selectors.ORGANISATIONS)),
      this.currentFilter
    ).pipe(
      map(([orgs, filter]) => {
        if (filter == "enabled") {
          return orgs.filter(org => org.enabled);
        }
        return orgs;
      })
    );
    this.loading$ = this.store.select(
      selectors.getLoadingAll(selectors.ORGANISATIONS)
    );
  }

  ngOnInit() {
    this.store.dispatch(Organisations.RequestAllAction);
  }

  updateFilter() {
    this.currentFilter.next(this.filterControl.value);
  }
}
